import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "7"
}), ___EmotionJSX("rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "7"
}), ___EmotionJSX("rect", {
  x: "14",
  y: "14",
  width: "7",
  height: "7"
}), ___EmotionJSX("rect", {
  x: "3",
  y: "14",
  width: "7",
  height: "7"
}));
export default SVG;